// noinspection GraphQLUnresolvedReference

export const getUserAddresses = /* GraphQL */ `
    query GetUserAddressInfo {
        users {
            id
            ... on User {
                id
                billingAddress {
                    ... on address_Entry {
                        id
                    }
                }
                shippingAddress {
                    ... on address_Entry {
                        id
                    }
                }
                userAddresses {
                    ... on address_Entry {
                        id
                        addressCity
                        addressName
                        streetAndNumber
                        supplement
                        title
                        postcode
                        country
                    }
                }
            }
        }
    }
`;

export const getUserSettings = /* GraphQL */ `
    query GetUserSettings {
        users {
            ... on User {
                shippingCost
                tax
            }
        }
    }
`;

export const getCurrentUserId = /* GraphQL */ `
    query GetCurrentUser {
        users {
            id
        }
    }
`;
